/* High-demand / pre-order block.
   Page order: offer → THIS BLOCK → photo ("Nobody looks at the slope
   anymore") → reviews.
   "Pre-order" and "Ships October 5" stay on screen: the chargeback line.
   Tracking copy: the number is emailed when the shipping label is created,
   not when the parcel ships. */
(function(){
var cfg=document.getElementById('ice-countdown-config');
var SHIP_LABEL=cfg?cfg.dataset.label:'Sale ends in';
var SHIP_AT=Date.parse(cfg?cfg.dataset.deadline:'2026-10-31T23:59:00Z');
if(!Number.isFinite(SHIP_AT))SHIP_AT=0;
var ended=cfg?cfg.dataset.ended:'Countdown ended';
function escapeText(t){return String(t).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];});}
var PHRASE='NOBODY LOOKS AT THE SLOPE';

function faces(){
var D=window.IF_DESIGNS||[];
var out='';
for(var i=0;i<D.length&&i<3;i++){
out+='<a href="#shop" aria-label="Choose '+escapeText(D[i].name)+'" data-if-face="'+i+'" style="flex:1;min-width:0;text-decoration:none;text-align:center;color:#fff!important;"><img src="'+D[i].img+'" alt="'+escapeText(D[i].name)+'" loading="lazy" width="130" height="150" style="width:100%;height:auto;aspect-ratio:4/5;border-radius:12px;object-fit:cover;border:2px solid #FF4D14;display:block;"><span style="display:block;font:700 12px/1.2 Barlow,sans-serif;margin-top:8px;">'+escapeText(D[i].name)+'</span></a>';
}
return out;
}

function tile(id,unit){
return '<div style="flex:1; min-width:0; background:#1B222B; border-radius:10px; padding:10px 0 8px; text-align:center;">'+
'<div id="'+id+'" style="font-family:Bebas Neue,sans-serif; color:#fff; font-size:clamp(30px,8vw,40px); line-height:1; letter-spacing:1px;">00</div>'+
'<div style="font-family:Barlow,sans-serif; color:#8892A0; font-size:9.5px; font-weight:800; letter-spacing:1.1px; margin-top:3px;">'+unit+'</div>'+
'</div>';
}
function colon(){return '<div style="font-family:Bebas Neue,sans-serif; color:#FF4D14; font-size:26px; line-height:1; align-self:center; padding-bottom:12px;">:</div>';}

function step(svg,label){
return '<div style="flex:1; min-width:0; text-align:center;">'+
'<div style="width:34px; height:34px; border-radius:50%; background:rgba(255,77,20,0.14); margin:0 auto 6px; display:flex; align-items:center; justify-content:center;">'+
'<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="#FF4D14" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">'+svg+'</svg></div>'+
'<div style="font-family:Barlow,sans-serif; color:#fff; font-size:12.5px; font-weight:800; line-height:1.25;">'+label+'</div>'+
'</div>';
}
function arrow(){return '<div style="color:#3A4450; font-size:14px; align-self:flex-start; padding-top:10px;">&rarr;</div>';}

function tick(){
var left=Math.max(0,SHIP_AT-Date.now());
if(!left){var host=document.getElementById('if-demand');if(host&&!host.dataset.expired){host.dataset.expired='true';var title=host.querySelector('h2');if(title)title.textContent='PICK YOUR FACE.';var intro=host.querySelector('p');if(intro)intro.textContent='Find your next mountain face.';var badge=host.querySelector('[data-sale-badge]');if(badge)badge.textContent='FREAK SEASON';var cta=host.querySelector('[data-sale-cta]');if(cta)cta.textContent='SHOP THE MASKS →';var n=host.querySelector('#if-dm-d');if(n){var row=n.parentElement.parentElement;var label=row.previousElementSibling;if(label)label.textContent=ended;}}}
var d=Math.floor(left/86400000);
var h=Math.floor(left/3600000)%24;
var m=Math.floor(left/60000)%60;
var s=Math.floor(left/1000)%60;
function p(n){return (n<10?'0':'')+n;}
[['if-dm-d',d],['if-dm-h',h],['if-dm-m',m],['if-dm-s',s]].forEach(function(x){var e=document.getElementById(x[0]);if(e)e.textContent=p(x[1]);});
}

function photoBlock(reviews){
var all=document.body.getElementsByTagName('*');
var hit=null;
for(var i=0;i<all.length;i++){
var el=all[i];
if(el.id==='if-demand'||(el.closest&&el.closest('#if-demand')))continue;
if(el.tagName==='SCRIPT'||el.tagName==='STYLE')continue;
var t=(el.textContent||'').toUpperCase();
if(t.indexOf(PHRASE)<0)continue;
var deeper=false;
for(var c=0;c<el.children.length;c++){
if((el.children[c].textContent||'').toUpperCase().indexOf(PHRASE)>-1){deeper=true;break;}
}
if(!deeper){hit=el;break;}
}
if(!hit||reviews.contains(hit))return null;
var n=hit;
while(n.parentNode&&!n.parentNode.contains(reviews))n=n.parentNode;
if(!n.parentNode||n===document.body)return null;
return n;
}
function anchor(){
var reviews=document.getElementById('reviews');
if(!reviews||!reviews.parentNode)return null;
return photoBlock(reviews)||reviews;
}
function place(){
var s=document.getElementById('if-demand');
var a=anchor();
if(!s||!a||a===s)return;
if(s.nextElementSibling!==a)a.parentNode.insertBefore(s,a);
s.querySelectorAll('[data-if-face]').forEach(function(link){if(link.dataset.bound)return;link.dataset.bound='true';link.addEventListener('click',function(){var buttons=document.querySelectorAll('#if-thumbs button');var i=Number(link.dataset.ifFace);if(buttons[i])buttons[i].click();});});
}

function build(){
if(document.getElementById('if-demand'))return true;
var a=anchor();
if(!a)return false;

var s=document.createElement('section');
s.id='if-demand';
s.setAttribute('style','background:#FF4D14; padding:clamp(32px,7vw,56px) clamp(16px,4vw,20px) clamp(34px,7vw,58px);');
s.innerHTML=
'<div style="max-width:520px; margin:0 auto;">'+

'<div style="text-align:center; margin-bottom:18px;">'+
'<span style="display:inline-flex; align-items:center; gap:7px; background:#12161C; color:#fff; font-family:Barlow,sans-serif; font-weight:800; font-size:10.5px; letter-spacing:1.6px; padding:6px 13px; border-radius:999px; margin-bottom:12px;"><span style="width:7px; height:7px; border-radius:50%; background:#FF4D14; display:block;"></span><span data-sale-badge>FREAK SEASON SALE</span></span>'+
'<h2 style="font-family:Bebas Neue,sans-serif; font-weight:400; color:#12161C; font-size:clamp(36px,10vw,56px); letter-spacing:1px; line-height:0.92; margin:0 0 10px;">PICK YOUR FACE.<br>GRAB THE DEAL.</h2>'+
'<p style="font-family:Barlow,sans-serif; color:#12161C; font-size:clamp(15px,3.7vw,16.5px); line-height:1.45; font-weight:600; margin:0 auto; max-width:380px;">Get your favourite mask before the offer ends.</p>'+
'</div>'+

'<div style="background:#12161C; border-radius:18px; padding:16px 16px 18px; box-shadow:0 18px 40px rgba(18,22,28,0.28);">'+

'<div style="display:flex; align-items:center; gap:12px; padding-bottom:14px; margin-bottom:14px; border-bottom:1px solid rgba(255,255,255,0.08);">'+
'<div style="display:flex;gap:10px;width:100%;">'+faces()+'</div>'+

'</div>'+

'<div style="font-family:Barlow,sans-serif; color:#FF4D14; font-size:10.5px; font-weight:800; letter-spacing:1.4px; text-align:center; margin-bottom:8px;">'+escapeText(SHIP_LABEL.toUpperCase())+'</div>'+
'<div style="display:flex; gap:5px; margin-bottom:18px;">'+
tile('if-dm-d','DAYS')+colon()+tile('if-dm-h','HRS')+colon()+tile('if-dm-m','MIN')+colon()+tile('if-dm-s','SEC')+
'</div>'+

'<a href="#shop" data-sale-cta style="display:block;background:#FF4D14;color:#fff!important;text-align:center;text-decoration:none;font:800 15px Barlow,sans-serif;padding:14px;border-radius:10px;">SHOP THE SALE &rarr;</a>'+
'</div>'+
'</div>';

a.parentNode.insertBefore(s,a);
s.querySelectorAll('[data-if-face]').forEach(function(link){if(link.dataset.bound)return;link.dataset.bound='true';link.addEventListener('click',function(){var buttons=document.querySelectorAll('#if-thumbs button');var i=Number(link.dataset.ifFace);if(buttons[i])buttons[i].click();});});
tick();
setInterval(tick,1000);
return true;
}

var k=0;
var iv=setInterval(function(){k++;build();place();if(k>100)clearInterval(iv);},300);
if(document.readyState!=='loading')build();else document.addEventListener('DOMContentLoaded',build);
})();

